function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,136.000000) scale(0.100000,-0.100000)",
  fill: "#57D5D1",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M595 1349 c-262 -38 -479 -220 -559 -469 -71 -222 -11 -488 149 -653 77 -81 101 -99 177 -140 292 -156 641 -80 855 185 96 119 154 329 133 481 -17 123 -70 258 -133 335 -85 106 -214 196 -337 236 -44 14 -188 37 -213 35 -7 -1 -39 -5 -72 -10z m-89 -327 c51 -50 91 -78 154 -109 146 -70 222 -89 404 -101 l130 -9 32 -37 c35 -40 49 -89 38 -133 -10 -44 -54 -95 -95 -111 -23 -9 -41 -24 -44 -36 -16 -55 -66 -134 -120 -191 -227 -236 -591 -176 -748 122 -20 39 -37 78 -37 87 0 9 -8 16 -20 16 -29 0 -87 56 -100 96 -25 75 16 158 96 194 81 35 234 209 234 266 0 8 2 14 4 14 2 0 35 -31 72 -68z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446 684 c-9 -8 -16 -22 -16 -30 0 -18 36 -54 54 -54 37 0 61 61 34 88 -17 17 -54 15 -72 -4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M842 688 c-27 -27 -3 -88 34 -88 18 0 54 36 54 54 0 37 -61 61 -88 34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492 368 c5 -35 89 -71 175 -76 64 -4 80 -1 138 26 49 23 65 36 65 51 0 28 -19 26 -71 -4 -63 -36 -175 -36 -238 0 -54 31 -73 32 -69 3z"
}));

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "136.000000pt",
    height: "136.000000pt",
    viewBox: "0 0 136.000000 136.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7428c29e.svg";
export { ForwardRef as ReactComponent };